import INotice from "@/types/INotice";

export interface IMerchant {
  adminId: number;
  adminName: string;
  city: string | undefined;
  country: string;
  isNewMerchant: boolean;
  isPayJoyOpen: boolean;
  languagePreference: string;
  merchantEmail: string;
  merchantId: number;
  merchantName: string;
  merchantPhone: number;
  reachedSalesLimits: boolean;
  showPricingPromoSection: string;
  showTotalCostColumn: string;
  state: string;
  street2: string | undefined;
  street: string | undefined;
  timeZone: string;
  welcomeCallPolicy: string;
  zip: number;
}

export interface IMerchantList {
  merchantId: number;
  merchantName: string;
}

export interface IMerchantResetPwdResponse {
  merchantName: string;
  deliveryMethod: string;
  deliveryDestination: string;
}

export interface IExperiments {
  isTandCNewUIExperimentM3?: boolean;
  uploadIdEnablePageM3?: boolean;
}

type FeatureFlags = { [key: string]: boolean };

interface IMerchantState {
  jwt: string | null;
  merchant: IMerchant | null;
  merchantFlags: string[];
  notices: INotice[];
  experiments?: IExperiments;
  featureFlags?: FeatureFlags;
  geolocationAllowed: boolean;
  geolocationCheckInProgress: boolean;
  geolocationCheckDone: boolean;
  geolocationActions: { [index: string]: boolean };
}

export enum MerchantCountry {
  BR = "BR",
  CO = "CO",
  EC = "EC",
  ID = "ID",
  MX = "MX",
  PA = "PA",
  PE = "PE",
  PH = "PH",
  ZA = "ZA",
}

export default IMerchantState;
